import * as React from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import BuildRounded from '@mui/icons-material/BuildRounded';
import SupervisorAccountRoundedIcon from '@mui/icons-material/SupervisorAccountRounded';

const actions = [
    {
      icon: <BuildRounded />,
      name: 'Assistência Técnica (Sul/Sudeste)',
      link: 'https://wa.me/+554591084120',
    },
    {
      icon: <BuildRounded />,
      name: 'Assistência Técnica (Norte/Centro-Oeste)',
      link: 'https://wa.me/+556599622632',
    },
    // {
    //   icon: <SupervisorAccountRoundedIcon />,
    //   name: 'Comercial - Vinicius (Sul/Sudeste)',
    //   link: 'https://wa.me/+554599714611',
    // },
    {
      icon: <SupervisorAccountRoundedIcon />,
      name: 'Comercial - Luciano',
      link: 'https://wa.me/+556599547518',
    },
  ];
export default function FloatingWhats() {
  return (
    <>
        <SpeedDial
            ariaLabel="WhatsApp"
            sx={{ position: 'fixed', bottom: 25, right: 25, color:'#000' }}
            icon={<img src='/images/icons/whatsapp.svg' style={{height:'35px', backgroundColor:'#474747', padding:'12px', borderRadius:'50px'}}/>}
        >
            {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          tooltipOpen
          onClick={() => window.open(action.link, '_blank')}
          sx={{
            
            '& .MuiSpeedDialAction-staticTooltipLabel': {
              whiteSpace: '',      
              width: 'max-content',
              maxWidth: '200px',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              fontSize: '14px',
              fontWeight: 600,
              padding: '5px 14px',
              textAlign: 'right',
            }
          }}
        />
      ))}

        </SpeedDial> 
    </>
  );
}